import React from "react";
import { mapToPdfData } from "../utils/pdfDataMapper";
import { generatePDFFromData } from "../utils/exportPDF";

export const GeneratePackagePDF = async (packageData) => {
  const data = mapToPdfData(packageData, "package");
  const name = packageData.packagename || "export";
  const filename = `package_${name.replace(/\s+/g, "_")}.pdf`;
  await generatePDFFromData(data, filename);
};

export const PackagePDFButton = ({ packageData }) => (
  <button
    className="p-2 bg-gray-200 rounded-md"
    onClick={() => GeneratePackagePDF(packageData)}
  >
    <span className="material-symbols-outlined">picture_as_pdf</span>
  </button>
);

export default GeneratePackagePDF;
